// Stammdaten mit Offline-Rueckfallebene: netzwerkzuerst, damit die Daten
// immer so aktuell wie moeglich sind, aber ein Fehlschlag (kein Netz) faellt
// auf die zuletzt in IndexedDB abgelegte Fassung zurueck statt auf einen
// Fehlerbildschirm. Kein ETag-Abgleich (Projektplan 10.1): Die Bundles sind
// klein genug, dass ein Neuladen bei jedem Start nicht ins Gewicht faellt,
// und ein Vergleich waere nur zusaetzlicher Code fuer denselben Fall.

import { api } from "./api.js";
import { db, type BundleEintrag } from "./db.js";

export async function holeBundleMitCache<T>(schluessel: BundleEintrag["key"], pfad: string): Promise<T> {
  try {
    const frisch = await api<T>(pfad);
    void db.bundles.put({ key: schluessel, data: frisch, fetchedAt: Date.now() });
    return frisch;
  } catch (fehler) {
    const zeile = await db.bundles.get(schluessel);
    if (zeile) return zeile.data as T;
    throw fehler;
  }
}
